import React from 'react';

const ScrollingBanner = () => {
  const handleClick = () => {
    window.open('https://www.panicproofretirement.com', '_blank');
  };

  return (
    <div className="bg-white py-2 overflow-hidden border-b border-gray-200 cursor-pointer" onClick={handleClick}>
      <div className="flex items-center">
        {/* Scrolling container */}
        <div className="flex animate-scroll-fast whitespace-nowrap">
          {/* Logo and Text */}
          <div className="flex items-center mr-8">
            <img 
              src="https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750775018003_177ef24e.jpg" 
              alt="Logo" 
              className="h-6 w-auto max-w-[1.5in] mr-3"
            />
            <span className="text-green-600 font-medium text-sm mr-2">Looking for safe money options?</span>
            <span className="text-green-600 hover:text-green-800 underline font-semibold text-sm">
              Click here...
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScrollingBanner;